import {
  STATE_CONTENT_ADDRESS_SYSTEM,
  STATE_DIALOG_ADDRESS_SYSTEM,
  STATE_MENU_ADDRESS_SYSTEM,
} from '@/constants/statesOfAddressSystem'

import {
  AddressSystemMap,
  AddressSystemState,
  AddressSystemStates,
} from '@/store/addressSystem/address-system.types'
import { getDefaultDeliveryAddress } from '@/store/addressSystem/address-system.utils'

import { DeliveryMethods } from '@/api/modules/basket/types'

export const DEFAULT_STATE_ADDRESS_SYSTEM: AddressSystemState = {
  isVisibleAddressSystemDialog: false,
  isLoadingWidget: true,
  selectedAddress: {
    address: null,
    coordinates: null,
  },
  delivery: {
    widget: {
      delivery_method: DeliveryMethods.COURIER,
    },
    basket: {
      delivery_method: DeliveryMethods.COURIER,
    },
  },
  deliveryAddress: getDefaultDeliveryAddress(),
}

export const DEFAULT_STATE_MAP: AddressSystemMap = {
  areas: [],
  points: [],
  isLoadingAreas: false,
  isShowClarifyAddress: false,
}

export const DEFAULT_STATE: AddressSystemStates = {
  dialogState: STATE_DIALOG_ADDRESS_SYSTEM.LOADING,
  prevDialogContent: STATE_CONTENT_ADDRESS_SYSTEM.NEW,
  dialogContent: STATE_CONTENT_ADDRESS_SYSTEM.NEW,
  menuState: STATE_MENU_ADDRESS_SYSTEM.DEFAULT,
}
